import { useId, useState } from "react";
import type { FormEvent } from "react";
import { Link } from "react-router-dom";
import { api } from "../../api/client";
import { t } from "../../i18n/t";
import { routes } from "../../lib/routes";
import { usePageTitle } from "../../lib/usePageTitle";

export function ForgotPasswordPage() {
  const id = useId();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  usePageTitle(t("auth.forgotTitle"));

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.POST("/api/auth/password-reset/request", { body: { email: email.trim() } });
    } catch {
      // Ignore: the page always shows the same neutral message (no account enumeration).
    }
    setBusy(false);
    setSent(true);
  }

  return (
    <div className="auth-card card">
      <h1>{t("auth.forgotTitle")}</h1>
      {sent ? (
        <p className="notice notice-success" role="status">
          {t("auth.forgotSent")}
        </p>
      ) : (
        <>
          <p className="muted">{t("auth.forgotIntro")}</p>
          <form onSubmit={(e) => void onSubmit(e)}>
            <div className="field">
              <label htmlFor={`${id}-email`}>{t("auth.email")}</label>
              <input
                id={`${id}-email`}
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
                {t("auth.forgotSubmit")}
              </button>
            </div>
          </form>
        </>
      )}
      <p>
        <Link to={routes.login()}>{t("auth.backToLogin")}</Link>
      </p>
    </div>
  );
}
